import { css, type Theme } from "@emotion/react";

import { hexToRgba } from "@styles/emotion-styles/helpers/hexToRgba/hexToRgba";

export const circleLoader = (theme: Theme) => css`
  @keyframes loader-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  border: 1px solid ${hexToRgba(theme.system.textHover, 0.2)};
  border-left-color: ${theme.success.borderBase};
  animation: loader-spin 1.2s infinite linear;
  position: relative;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: 3em;
  height: 3em;

  &.inline {
    width: 1em;
    height: 1em;
    vertical-align: text-bottom;
  }
`;
